export default __webpack_public_path__ + "static/media/1212.8667c94d.png";